import { render, staticRenderFns } from "./alert-header.vue?vue&type=template&id=bc2cfb30&"
import script from "./alert-header.vue?vue&type=script&lang=js&"
export * from "./alert-header.vue?vue&type=script&lang=js&"
import style0 from "./alert-header.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports